import React, { useEffect, useRef, useState } from 'react';
import { useLang } from '../LangContext';

const featureIcons = [
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/><path d="M7 8h2l1 3 1-4 1 3h2"/></svg>,
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>,
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M13 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V9z"/><polyline points="13 2 13 9 20 9"/></svg>,
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>,
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/></svg>,
];

function FeatureCard({ item, icon, i, visible }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}
      style={{
        padding: '1.75rem 1.5rem',
        background: hovered ? 'rgba(255,60,60,0.04)' : 'var(--bg2)',
        transition: 'background 0.2s, opacity 0.5s, transform 0.5s',
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(20px)',
        transitionDelay: `${i * 0.07}s`,
        cursor: 'default',
      }}>
      <div style={{
        width: '40px', height: '40px', borderRadius: '10px',
        background: hovered ? 'rgba(255,60,60,0.15)' : 'rgba(255,255,255,0.05)',
        border: `1px solid ${hovered ? 'rgba(255,60,60,0.3)' : 'rgba(255,255,255,0.07)'}`,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        marginBottom: '1rem', transition: 'all 0.2s',
        color: hovered ? 'var(--brand)' : 'var(--text2)',
      }}>
        {icon}
      </div>
      <h3 style={{ fontFamily: 'var(--font-display)', fontSize: '15px', fontWeight: 700, color: 'var(--text)', marginBottom: '6px' }}>
        {item.title}
      </h3>
      <p style={{ fontSize: '13px', color: 'var(--text2)', lineHeight: 1.6, fontWeight: 300 }}>
        {item.desc}
      </p>
    </div>
  );
}

export default function Features() {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.1 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="fitur" ref={ref} style={{ padding: '6rem 1.5rem', maxWidth: '1000px', margin: '0 auto' }}>
      <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
        <div style={{
          display: 'inline-block',
          background: 'rgba(255,60,60,0.08)', border: '1px solid rgba(255,60,60,0.15)',
          borderRadius: '99px', padding: '4px 14px', marginBottom: '1rem',
        }}>
          <span style={{ fontSize: '11px', color: 'var(--brand)', fontWeight: 500, letterSpacing: '0.08em', textTransform: 'uppercase' }}>
            {t.features.sectionBadge}
          </span>
        </div>
        <h2 style={{
          fontFamily: 'var(--font-display)', fontSize: 'clamp(1.6rem, 4vw, 2.4rem)',
          fontWeight: 800, letterSpacing: '-0.02em', color: 'var(--text)', marginBottom: '0.75rem',
        }}>{t.features.headline}</h2>
        <p style={{ fontSize: '15px', color: 'var(--text2)', fontWeight: 300 }}>{t.features.sub}</p>
      </div>

      <div style={{
        display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
        gap: '1px', background: 'rgba(255,255,255,0.05)',
        borderRadius: '16px', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.05)',
      }}>
        {t.features.items.map((item, i) => (
          <FeatureCard key={i} item={item} icon={featureIcons[i]} i={i} visible={visible} />
        ))}
      </div>
    </section>
  );
}
